$(document).ready(function () {
    // Check if the user prefers reduced motion
    const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Select the video and control button
    const video = $('.block-video')[0]; // Grab the first video element (if there are multiple)
    const videoControl = $('.video-control');

    // If reduced motion is preferred, pause the video initially
    if (isReduced && video) {
        video.pause(); // Pause the video on load
        videoControl.addClass('pause').removeClass('play'); // Ensure the button shows 'pause' initially
    }

    // Handle play/pause when clicking the video control button
    videoControl.on('click', function () {
        if (video.paused) {
            // Play the video and update the button class
            video.play();
            $(this).removeClass('pause').addClass('play');
        } else {
            // Pause the video and update the button class
            video.pause();
            $(this).removeClass('play').addClass('pause');
        }
    });
});
